import { render, staticRenderFns } from "./businessCircleApply.vue?vue&type=template&id=2bc5c8d0&scoped=true"
import script from "./businessCircleApply.vue?vue&type=script&lang=js"
export * from "./businessCircleApply.vue?vue&type=script&lang=js"
import style0 from "./businessCircleApply.vue?vue&type=style&index=0&id=2bc5c8d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc5c8d0",
  null
  
)

export default component.exports